const LOCAL_STORAGE_DATE_KEY = 'invoice_date';

export function getInvoiceDate(): string {
    const storedDate = localStorage.getItem(LOCAL_STORAGE_DATE_KEY);

  if (storedDate) {
    return storedDate;
  }

  const today = new Date().toLocaleDateString(); 
  localStorage.setItem(LOCAL_STORAGE_DATE_KEY, today);
  return today;
}

export function setInvoiceDate(date: string) {
  localStorage.setItem(LOCAL_STORAGE_DATE_KEY, date);
}
